import { render, staticRenderFns } from "./media-tag-form.vue?vue&type=template&id=22bff442&scoped=true"
import script from "./media-tag-form.vue?vue&type=script&setup=true&lang=js"
export * from "./media-tag-form.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bff442",
  null
  
)

export default component.exports